import unescape from 'lodash-es/unescape';

import eventBus from '../eventBus';
import $ from '../jquery';
import Rover from '../Rover';
// Do this all very quickly, don't wait for document ready
window.dataLayer = window.dataLayer || []; // Google Tag Manager (GTM)

function isFunction(obj) {
  return typeof obj === 'function';
}

export default class CurrentUser {
  observable: typeof eventBus;

  url: string;

  apiUrl: string;

  authenticated?: boolean;

  isSitter: boolean;

  listsAllServices: boolean;

  firstName: string;

  lastName: string;

  email: string;

  smallPhotoUrl: string;

  unreadMessageCount: number;

  hasDogs: boolean;

  shouldPromptForPets: boolean;

  zip: string;

  timeZone: string;

  opk: string;

  constructor() {
    this.observable = eventBus;
    this.url = Rover.urls.currentPerson;
    // Properties
    this.apiUrl = '';
    this.authenticated = undefined;
    this.isSitter = false;
    this.listsAllServices = false;
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.smallPhotoUrl = '';
    this.unreadMessageCount = 0;
    this.hasDogs = false;
    this.shouldPromptForPets = false;
    this.zip = '';
    this.timeZone = '';
    this.opk = '';
    // Fetch user data
    this.fetch();
  }

  getOpk(): string {
    if (this.apiUrl.indexOf('/') !== -1) {
      return this.apiUrl.split('/').slice(-2, -1).pop() || '';
    }

    return '';
  }

  on(label: string, cb: (...args: any[]) => void): void {
    if (isFunction(cb)) {
      this.observable.$on(label, cb);
    }
  }

  off(label: string, cb: (...args: any[]) => void): void {
    if (isFunction(cb)) {
      this.observable.$off(label, cb);
    }
  }

  fetch(): void {
    $.getJSON(this.url, (data) => {
      Object.assign(this, data);
      this.opk = this.getOpk();
      // Run callbacks registered
      this.observable.$emit('user:loaded', data);

      if (this.authenticated === true) {
        this.firstName = unescape(this.firstName);
        this.lastName = unescape(this.lastName);
        this.observable.$emit('user:authenticated');
      } else if (this.authenticated === false) {
        this.observable.$emit('user:anonymous');
      }
    });
  }

  /**
   * Runs the callback provided if the user is setup.
   * Otherwise, registers the callback to be called
   * when the user has been fully setup
   */
  waitForUserLoaded(): Promise<CurrentUser> {
    return new Promise((resolve) =>
      this.authenticated !== undefined ? resolve(this) : this.on('user:loaded', () => resolve(this))
    );
  }

  /**
   * Runs the callback provided if the user is authenticated already.
   * Otherwise, registers the callback to be called when the user
   * has been fully setup and the user is authenticated
   */
  waitForAuthenticatedUserLoaded(): Promise<CurrentUser> {
    return new Promise((resolve, reject) => {
      if (this.authenticated === true) {
        resolve(this);
      } else {
        this.on('user:authenticated', () => resolve(this));
        this.on('user:anonymous', () => reject(this)); // eslint-disable-line
      }
    });
  }

  /**
   * Runs the callback provided if the user is anonymous.
   * Otherwise, registers the callback to be called when the user
   * has been fully setup and the user is anonymous
   */
  waitForAnonymousUserLoaded(): Promise<CurrentUser> {
    return new Promise((resolve, reject) => {
      if (this.authenticated === false) {
        resolve(this);
      } else {
        this.on('user:anonymous', () => resolve(this));
        this.on('user:authenticated', () => reject(this)); // eslint-disable-line
      }
    });
  }
}



// WEBPACK FOOTER //
// ../globals/currentUser/CurrentUser.ts